import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function RusselMorganEPLawyerPage() {
  return <AttorneyBioTemplate attorney={attorneys['russel-morgan-estate-planning-lawyer-in-nyc']} />;
}
